<template>
<div class="mt-5">
  <Article></Article>
</div>
</template>

<script>
import {
  checkAccess
} from "@/scripts/groupFuncs";
import Article from "@/components/Posts/Article";

export default {
  name: "ArticlePage",
  components: {
    Article
  }
};
</script>



// WEBPACK FOOTER //
// src/views/ArticlePage.vue